import React from 'react';
import { trustPillars } from '../mock';
import { Cpu, FileSearch2, FileDown } from 'lucide-react';

const Icons = [Cpu, FileSearch2, FileDown];

export default function Trust() {
  return (
    <section className="relative">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#1B6F5E] font-medium">
              Explainability · Traceability · Control
            </div>
            <h2 className="mt-3 font-display text-[40px] lg:text-[56px] leading-[1.02] text-[#0B1F2D]">
              Built for the
              <br />
              <span className="italic">people who sign.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] leading-[1.6] text-[#0B1F2D]/70 max-w-[640px]">
              ESGine® is built for explainability, traceability, and control. Every finding is rule-based, every outcome
              is auditable, and every result is exportable for boards, auditors, and regulators.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {trustPillars.map((p, i) => {
            const Ico = Icons[i];
            return (
              <div
                key={p.title}
                className="card-lift rounded-2xl border border-[#E8E5DC] bg-white p-8"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl bg-[#E8F3EE] text-[#1B6F5E] flex items-center justify-center">
                    <Ico className="w-5 h-5" />
                  </div>
                  <div className="font-mono-tight text-[11px] text-[#0B1F2D]/45">
                    /{['logic', 'evidence', 'export'][i]}
                  </div>
                </div>
                <div className="mt-7 font-display text-[24px] leading-[1.15] text-[#0B1F2D]">{p.title}</div>
                <p className="mt-3 text-[14px] leading-[1.6] text-[#0B1F2D]/65">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
